import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: auto min-content;
  gap: 10px;
  justify-content: flex-end;
`;

export const ToggleExtraButton = styled.div`
  margin-left: 10px;
`;

export const PerStayWrapper = styled.div`
  display: grid !important;
  grid-template-columns: 1fr;
  gap: 10px;
`;
